import { render } from "./reset-password-step1.vue?vue&type=template&id=544b73be&scoped=true"
import script from "./reset-password-step1.vue?vue&type=script&lang=js"
export * from "./reset-password-step1.vue?vue&type=script&lang=js"

import "./reset-password-step1.vue?vue&type=style&index=0&id=544b73be&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./reset-password-step1.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544b73be"]])

export default __exports__